import "../css/style.scss";
import { useEffect, useRef } from "react";
import { motion, useInView, useAnimation } from "motion/react";
import { inView } from "motion";

export default function Reveal({ children, delay = 0.2, inViewAmount = 0.5 }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: inViewAmount });
  const mainControls = useAnimation();
  useEffect(() => {
    if (isInView) {
      mainControls.start("visible");
    }
  }, [isInView]);

  return (
    <div ref={ref} style={{ position: "relative", overflow: "hidden" }}>
      <motion.div
        variants={{
          hidden: { opacity: 0, y: 100 },
          visible: { opacity: 1, y: 0 },
        }}
        initial="hidden"
        animate={mainControls}
        transition={{ duration: 0.5, delay: delay, ease: "easeOut" }}
      >
        {children}
      </motion.div>
    </div>
  );
}
